// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"300cb86f","703":"20786cc6","787":"8c3ea949"}[chunkId] + ".chunk.js";
};